import { Component, ContentChild, Input, TemplateRef } from '@angular/core';
import { IViewItemConfig } from './models/view-item-config.model';

@Component({
  selector: 'app-tqw-view-item',
  templateUrl: './tqw-view-item.component.html',
  styleUrls: ['./tqw-view-item.component.scss']
})
export class TqwViewItemComponent  {
  @ContentChild(TemplateRef) viewItemValue!: TemplateRef<unknown>;

  @Input() config!: IViewItemConfig;

}
